<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>周数据</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="90" :show-message="false" label-position="right">
        <Row :gutter="24">
          <Col span="6">
            <Form-item label="周时间">
              <Input v-model="queryParam.periodLabel" placeholder="如 2026-10"></Input>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item>
              <Button type="primary" :loading="searchLoading" @click="search">查询</Button>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>
    <Table :columns="columns" :data="tableData" :loading="tableLoading" border stripe></Table>
    <div style="margin-top: 12px; text-align: right">
      <Page :total="totalCount" :current="queryParam.pageIndex" :page-size="queryParam.pageSize"
            show-total show-sizer :page-size-opts="[20, 50, 100]"
            @on-change="onPageChange" @on-page-size-change="onPageSizeChange"></Page>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StudentWeekStatList',
  data () {
    return {
      searchLoading: false,
      tableLoading: false,
      totalCount: 0,
      tableData: [],
      queryParam: {
        periodLabel: '',
        pageIndex: 1,
        pageSize: 20
      },
      columns: [
        {title: '部门', key: 'deptName', minWidth: 90},
        {title: '周时间', key: 'periodLabel', minWidth: 180},
        {title: '总学生', key: 'totalStudent', minWidth: 90},
        {title: '在读学生', key: 'activeStudent', minWidth: 90},
        {title: '停课学生', key: 'stopStudent', minWidth: 90},
        {title: '一周一节课学生', key: 'oneWeekOneLesson', minWidth: 120},
        {title: '新增量', key: 'newAssign', minWidth: 80},
        {title: '结课量', key: 'finishCount', minWidth: 80},
        {title: '课耗', key: 'consumeNum', minWidth: 80},
        {title: '提前请假', key: 'earlyLeave', minWidth: 90},
        {title: '临时请假', key: 'tempLeave', minWidth: 90},
        {title: '缺席', key: 'absentNum', minWidth: 80},
        {title: '学导原因返还课时', key: 'adviserReturnNum', minWidth: 140}
      ]
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    search () {
      this.queryParam.pageIndex = 1
      this.loadData()
    },
    onPageChange (p) {
      this.queryParam.pageIndex = p
      this.loadData()
    },
    onPageSizeChange (s) {
      this.queryParam.pageSize = s
      this.queryParam.pageIndex = 1
      this.loadData()
    },
    loadData () {
      const self = this
      self.searchLoading = true
      self.tableLoading = true
      const url = '/studentWeekStat/list'
      self.$http.post(url, self.queryParam).then(function (res) {
        self.searchLoading = false
        self.tableLoading = false
        if (res && res.status === 'ok' && res.data) {
          self.tableData = res.data.data || []
          self.totalCount = res.data.totalCount || 0
        }
      }).catch(function () {
        self.searchLoading = false
        self.tableLoading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// StudentWeekStatList.vue?0ac34d7c